import { NOT_FOUND } from 'redux-first-router';
import { ROUTES } from '../constants'; 
export const componentNames = {
	[ROUTES.SEARCH_QUIZ_SELECTED]: 'RedirectToSearch',
	[ROUTES.SEARCH_QUIZ_QUERIED]: 'SearchQuiz',
	[ROUTES.CREATE_QUIZ_SELECTED]: 'CreateQuiz',
	[ROUTES.SHOW_RECIPE]: 'CreateQuiz',
	[ROUTES.REQUEST_QUIZ_EDITOR]: 'CreateQuiz',
	[ROUTES.REQUEST_PLAY_QUIZ]: 'PlayQuiz',
	[ROUTES.RECIPE_DETAIL]: 'RecipeDetail',
	[ROUTES.PROFILE]: 'Profile',
	[ROUTES.USER] : 'User',
	[ROUTES.LANDING_PAGE] : 'LandingPage',
	[ROUTES.HOME_PAGE] : 'HomePage',
	[ROUTES.TERMS_PAGE] : 'TermsPage',
	[ROUTES.PRIVACY_POLICY_PAGE] : 'PrivacyPolicyPage',
	[NOT_FOUND]: 'NotFound'
};

export default (state = 'HOME', action = {}) => {
	return componentNames[action.type] || state;
};